/**
 * Supplier Formatter.
 * @param {*} value
 * @param {object} row
 * @returns {string}
 */
window.supplierFormatter = function(value, row) {
    let html = '';
    if (value) {
        html += '<a href="/admin/suppliers/show/'+row.supplier_id+'">';
        html += value;
        html += '</a>';
    }
    return html;
}
